export const API_DATA_SUCCESS = 'API_DATA_SUCCESS';
export const API_DATA_LOADING = 'API_DATA_LOADING';
export const API_DATA_FAILURE = 'API_DATA_FAILURE';
export const API_SUBMISSION_SUCCESS = 'API_SUBMISSION_SUCCESS';
export const API_SUBMISSION_FAILURE = 'API_SUBMISSION_FAILURE';
export const API_SUBMISSION_LOADING = 'API_SUBMISSION_LOADING';
export const API_LOGIN_SUCCESS = 'API_LOGIN_SUCCESS';
export const API_LOGIN_FAILURE = 'API_LOGIN_FAILURE';
export const API_LOGIN_LOADING = 'API_LOGIN_LOADING';
export const LAST_BLURRED_FIELD = 'LAST_BLURRED_FIELD';
export const API_HELP_SUCCESS = 'API_HELP_SUCCESS';
export const API_HELP_LOADING = 'API_HELP_LOADING';
export const API_HELP_FAILURE = 'API_HELP_FAILURE';
export const API_SEATTYPES_SUCCESS = 'API_SEATTYPES_SUCCESS';
export const API_SEATTYPES_LOADING = 'API_SEATTYPES_LOADING';
export const API_SEATTYPES_FAILURE = 'API_SEATTYPES_FAILURE';
export const API_CHILDAGES_SUCCESS = 'API_CHILDAGES_SUCCESS';
export const API_CHILDAGES_LOADING = 'API_CHILDAGES_LOADING';
export const API_CHILDAGES_FAILURE = 'API_CHILDAGES_FAILURE';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const API_PAYMENTCARDTYPES_SUCCESS = 'API_PAYMENTCARDTYPES_SUCCESS';
export const API_PAYMENTCARDTYPES_LOADING = 'API_PAYMENTCARDTYPES_LOADING';
export const API_PAYMENTCARDTYPES_FAILURE = 'API_PAYMENTCARDTYPES_FAILURE';
export const API_PAYMENTCOUNTRIES_SUCCESS = 'API_PAYMENTCOUNTRIES_SUCCESS';
export const API_PAYMENTCOUNTRIES_LOADING = 'API_PAYMENTCOUNTRIES_LOADING';
export const API_PAYMENTCOUNTRIES_FAILURE = 'API_PAYMENTCOUNTRIES_FAILURE';
export const API_FORGOT_FAILURE = 'API_FORGOT_FAILURE';
export const API_FORGOT_SUCCESS = 'API_FORGOT_SUCCESS';
export const API_FORGOT_LOADING = 'API_FORGOT_LOADING';
export const API_RESET_FAILURE = 'API_RESET_FAILURE';
export const API_RESET_SUCCESS = 'API_RESET_SUCCESS';
export const API_RESET_LOADING = 'API_RESET_LOADING';
export const API_VALIDATEPAYMENT_FAILURE = 'API_VALIDATEPAYMENT_FAILURE';
export const API_VALIDATEPAYMENT_SUCCESS = 'API_VALIDATEPAYMENT_SUCCESS';
export const API_VALIDATEPAYMENT_LOADING = 'API_VALIDATEPAYMENT_LOADING';
export const API_MAKEPAYMENT_FAILURE = 'API_MAKEPAYMENT_FAILURE';
export const API_MAKEPAYMENT_LOADING = 'API_MAKEPAYMENT_LOADING';
export const API_MAKEPAYMENT_SUCCESS = 'API_MAKEPAYMENT_SUCCESS';
export const API_UPDATEUSER_FAILURE = 'API_UPDATEUSER_FAILURE';
export const API_UPDATEUSER_SUCCESS = 'API_UPDATEUSER_SUCCESS';
export const API_UPDATEUSER_LOADING = 'API_UPDATEUSER_LOADING';
export const API_RECORDPAYMENT_FAILURE = 'API_RECORDPAYMENT_FAILURE';
export const API_RECORDPAYMENT_LOADING = 'API_RECORDPAYMENT_LOADING';
export const API_RECORDPAYMENT_SUCCESS = 'API_RECORDPAYMENT_SUCCESS';



// WEBPACK FOOTER //
// ./src/actions/constants.js